import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
import {
  futureDateWithTodayValidation,
  // richTextValidation,
} from "@validations/utils";

export const RETIREMENT = FORM_FIELDS.RETIREMENT;
export const BASIC_INFO = RETIREMENT.BASIC_INFO;
export const SUPPORTING_DOCUMENT = RETIREMENT.SUPPORTING_DOCUMENT;
export const RICH_TEXT_EDITOR = RETIREMENT.RICH_TEXT_EDITOR;
export const MODAL = RETIREMENT.MODAL;

export const retirementFormValidation = yup.object().shape({
  [BASIC_INFO.RETIREMENT_DATE]: yup
    .string()
    .when("demo", {
      is: "create",
      then: (schema) =>
        schema.test("validator-date", futureDateWithTodayValidation),
    })
    .required("Retirement date is required"),
  // [RICH_TEXT_EDITOR]: richTextValidation(),
  [SUPPORTING_DOCUMENT.EMPLOYEE_SUPPORTING_DOCUMENT]: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .required("Document is required"),
});

export type RetirementFormDataType = yup.InferType<
  typeof retirementFormValidation
>;
